/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminMembershipPolicyDto, AdminMembershipPolicyRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminMembershipPolicyService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminMembershipPolicyService
   * @name GetMembershipPolicy
   * @summary Get Membership Policy by ID
   * @request GET:/v1/admin/membership-policies/{policyId}
   * @secure
   */
  getMembershipPolicy = (policyId: number, params: RequestParams = {}) =>
    this.http.request<AdminMembershipPolicyDto, any>({
      path: `/v1/admin/membership-policies/${policyId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMembershipPolicyService
   * @name UpdateMembershipPolicy
   * @summary Update Membership Policy
   * @request PUT:/v1/admin/membership-policies/{policyId}
   * @secure
   */
  updateMembershipPolicy = (
    policyId: number,
    data: AdminMembershipPolicyRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<AdminMembershipPolicyDto, any>({
      path: `/v1/admin/membership-policies/${policyId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMembershipPolicyService
   * @name DeleteMembershipPolicy
   * @summary Delete Membership Policy
   * @request DELETE:/v1/admin/membership-policies/{policyId}
   * @secure
   */
  deleteMembershipPolicy = (policyId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/membership-policies/${policyId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMembershipPolicyService
   * @name GetMembershipPolicies1
   * @summary Get Membership Policies
   * @request GET:/v1/admin/membership-policies
   * @secure
   */
  getMembershipPolicies1 = (params: RequestParams = {}) =>
    this.http.request<AdminMembershipPolicyDto[], any>({
      path: `/v1/admin/membership-policies`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminMembershipPolicyService
   * @name CreateMembershipPolicy
   * @summary Create Membership Policy
   * @request POST:/v1/admin/membership-policies
   * @secure
   */
  createMembershipPolicy = (data: AdminMembershipPolicyRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminMembershipPolicyDto, any>({
      path: `/v1/admin/membership-policies`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
